import api from '@/api'
import errors from '@/api/errors'
import store from '@/store'

const baseUrlReg = process.env.REVIEW_API_BASE_URL_REG

const createPostParams = (args) => {
  const p = {}
  // required
  p.accessToken = store.getters['commons/cookies'].mchat
  p.sessionID = store.getters['commons/cookies'].encsid
  p.review_id = args.reviewId
  p.application = 2
  return p
}

const createDeleteParams = (args) => {
  const p = {}
  // required
  p.accessToken = store.getters['commons/cookies'].mchat
  p.sessionID = store.getters['commons/cookies'].encsid
  p.clip_id = args.clipId
  return p
}

const onReceived = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return Promise.resolve(respBody.data)
}

export default {
  // 役に立った登録
  clipReview: (args) => {
    const params = createPostParams(args)
    return api.post(`${baseUrlReg}/clipReview`, params).then(onReceived)
  },
  // 役に立った削除
  unclipReview: (args) => {
    const params = createDeleteParams(args)
    return api.post(`${baseUrlReg}/unclipReview`, params).then(onReceived)
  }
}



// WEBPACK FOOTER //
// ./src/api/clips.js